<template>
  <b-col cols="12" lg="6" class="py-sm-64 py-lg-0">
    <b-row cols="6">
      <b-button
        size="sm"
        @click="prevSlide()"
        variant="link"
        class="text-black-100 hp-hover-text-color-black-60"
      >
        <i
          class="hp-text-color-black-100 hp-text-color-dark-0 ri-arrow-left-s-line"
          style="font-size: 24px"
        ></i>
        Назад
      </b-button>
    </b-row>

    <b-row align-v="center" align-h="center" class="h-100 mx-4 mx-sm-n32">
      <b-col
        cols="12"
        md="9"
        xl="7"
        class="col-xxxl-5 px-8 px-sm-0 pt-24 pb-48"
      >
        <h1 class="mb-0 mb-sm-24">Карточка юридического лица</h1>
        <p class="mt-sm-8 mt-sm-0 text-black-60">
          Пожалуйста заполните необходимую информацию, чтобы иметь возможность
          пользоваться нашим сервисом
        </p>

        <ValidationObserver v-slot="{ valid }">
          <b-form @submit="nextSlide" class="mt-16 mt-sm-32 mb-8">
            <validation-provider
              name="название организации"
              :rules="{ required: true }"
              v-slot="{ dirty, valid, invalid, errors }"
            >
              <b-form-group
                label="Название организации :"
                label-for="orgName"
                class="mb-16"
              >
                <b-form-input
                  v-model="org_name"
                  id="orgName"
                  type="text"
                  v-bind:class="{
                    'is-valid': dirty && valid,
                    'is-invalid': dirty && invalid,
                  }"
                ></b-form-input>
              </b-form-group>
            </validation-provider>

            <validation-provider
              name="ИНН"
              :rules="{ required: true, regex: /^[\d+]{10,12}$/ }"
              v-slot="{ dirty, valid, invalid, errors }"
            >
              <b-form-group label="ИНН :" label-for="inn" class="mb-16">
                <b-form-input
                  v-model="inn"
                  id="inn"
                  type="text"
                  v-bind:class="{
                    'is-valid': dirty && valid,
                    'is-invalid': dirty && invalid,
                  }"
                ></b-form-input>
              </b-form-group>
            </validation-provider>

            <validation-provider
              name="КПП"
              :rules="{ required: true, regex: /\d{4}[\dA-Z][\dA-Z]\d{3}/ }"
              v-slot="{ dirty, valid, invalid, errors }"
            >
              <b-form-group label="КПП :" label-for="kpp" class="mb-16">
                <b-form-input
                  v-model="kpp"
                  id="kpp"
                  type="text"
                  v-bind:class="{
                    'is-valid': dirty && valid,
                    'is-invalid': dirty && invalid,
                  }"
                ></b-form-input>
              </b-form-group>
            </validation-provider>

            <validation-provider
              name="юридический адрес"
              :rules="{ required: true }"
              v-slot="{ dirty, valid, invalid, errors }"
            >
              <b-form-group
                label="Юридический адрес :"
                label-for="legal-address"
                class="mb-16"
              >
                <b-form-input
                  v-model="legal_address"
                  id="legal-address"
                  type="text"
                  v-bind:class="{
                    'is-valid': dirty && valid,
                    'is-invalid': dirty && invalid,
                  }"
                ></b-form-input>
              </b-form-group>
            </validation-provider>

            <validation-provider
              name="email для выставления счетов"
              :rules="{ required: true, email: true }"
              v-slot="{ dirty, valid, invalid, errors }"
            >
              <b-form-group
                label="Email для выставления счетов :"
                label-for="billing-email"
                class="mb-16"
              >
                <b-form-input
                  v-model="billing_email"
                  id="billing-email"
                  type="email"
                  v-bind:class="{
                    'is-valid': dirty && valid,
                    'is-invalid': dirty && invalid,
                  }"
                ></b-form-input>
              </b-form-group>
            </validation-provider>

            <validation-provider
              name="согласие с офертой"
              :rules="{ required: true }"
              v-slot="{ dirty, valid, invalid, errors }"
            >
              <b-form-checkbox
                name="agreed"
                v-bind:class="{
                  'is-valid': dirty && valid,
                  'is-invalid': dirty && invalid,
                }"
                v-model="agreed"
                required
              >
                Cоглашаюсь с <a href="/">Договором офертой</a></b-form-checkbox
              >
            </validation-provider>
            <b-form-checkbox v-model="email_deal">
              Выслать оферту на Email</b-form-checkbox
            >

            <!--ошибка при регистрации-->
            <div v-if="errorMessage" class="text-danger hp-d-block hp-badge-text text-center mt-3">
              {{ errorMessage }}
            </div>

            <b-button
              type="submit"
              variant="primary"
              class="mt-3 w-100"
              :disabled="!valid"
            >
              Зарегистрироваться
            </b-button>
          </b-form>
        </ValidationObserver>
        <footer-item />
      </b-col>
    </b-row>
  </b-col>
</template>

<script>
import {
  BRow,
  BCol,
  BButton,
  BLink,
  BForm,
  BFormGroup,
  BFormInput,
  BFormCheckbox,
} from "bootstrap-vue";

import LeftItem from "../LeftItem.vue";
import FooterItem from "../FooterItem.vue";

export default {
  props: {
    errorMessage: {
      type: String,
      default: null,
    }
  },
  data() {
    return {
      org_name: this.$store.state.register.org_name,
      legal_address: this.$store.state.register.legal_address,
      inn: this.$store.state.register.inn,
      kpp: this.$store.state.register.kpp,
      billing_email: this.$store.state.register.billing_email,
      agreed: this.$store.state.register.agreed,
      email_deal: this.$store.state.register.email_deal,
    };
  },
  components: {
    BRow,
    BCol,
    BButton,
    BLink,
    BForm,
    BFormGroup,
    BFormInput,
    BFormCheckbox,
    LeftItem,
    FooterItem,
  },
  methods: {
    nextSlide(event) {
      event.preventDefault();
      this.$store.state.register.org_name = this.org_name;
      this.$store.state.register.legal_address = this.legal_address;
      this.$store.state.register.inn = this.inn;
      this.$store.state.register.kpp = this.kpp;
      this.$store.state.register.billing_email = this.billing_email;
      this.$store.state.register.agreed = this.agreed;
      this.$store.state.register.email_deal = this.email_deal;
      this.$emit("nextSlide");
    },
    prevSlide() {
      this.$emit("prevSlide");
    },
  },
};
</script>
